import { documentCompletion } from './document-completion';

export default function documentsCompletion(documents) {
  if (!documents || documents.length === 0) {
    return 0;
  }

  let completionTotals = 0;
  documents.forEach(
    document => (completionTotals += documentCompletion(document).completion)
  );

  return completionTotals / documents.length;
}
